// SPDX-License-Identifier: AGPL-3.0-or-later

export type VoiceRecoveryDiagnosticState =
	| 'healthy'
	| 'transport-reconnecting'
	| 'transport-reconnected'
	| 'receive-stalled'
	| 'playback-suspended'
	| 'recovered'
	| 'unrecoverable';

export interface VoiceRecoveryDiagnosticEntry {
	at: string;
	state: VoiceRecoveryDiagnosticState;
	packetsReceived?: number;
	recoveryAttempt?: number;
}

const MAX_ENTRIES = 24;
const entries: Array<VoiceRecoveryDiagnosticEntry> = [];

export function recordVoiceRecoveryDiagnostic(
	state: VoiceRecoveryDiagnosticState,
	metadata: Omit<VoiceRecoveryDiagnosticEntry, 'at' | 'state'> = {},
): void {
	entries.push({at: new Date().toISOString(), state, ...metadata});
	if (entries.length > MAX_ENTRIES) entries.splice(0, entries.length - MAX_ENTRIES);
}

export function getVoiceRecoveryDiagnostics(): Array<VoiceRecoveryDiagnosticEntry> {
	return entries.map((entry) => ({...entry}));
}
